// Design tokens for the lobby / match-setup screens (Create lobby, Join lobby,
// Play locally). Kept in one place so the three screens stay visually identical.
// These match the OpenFront/Catan-inspired mock we iterated on in /playground.

export const C = {
  bg: "#070a12",
  panel: "#0e1422",
  panel2: "#111a2b",
  line: "rgba(255,255,255,0.08)",
  txt: "#eaf0ff",
  muted: "#8995b3",
  accent: "#28c4d4",
  pink: "#ff2e88",
  green: "#7CFC66",
};

export const UI = '"Rajdhani", sans-serif'; // body / controls
export const LB = '"Orbitron", sans-serif'; // labels / headings

// rgba() from a hex or an existing rgb/rgba string + alpha.
export function rgba(color: string, a: number): string {
  if (color.startsWith("#")) {
    const h = color.slice(1);
    const n = h.length === 3 ? h.split("").map((c) => c + c).join("") : h;
    const r = parseInt(n.slice(0, 2), 16);
    const g = parseInt(n.slice(2, 4), 16);
    const b = parseInt(n.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  return color;
}

// Bot difficulty label -> engine skill (1-10). "Off" means no auto-fill bots.
export type Difficulty = "Off" | "Easy" | "Medium" | "Hard";
export const SKILL_BY_DIFFICULTY: Record<Exclude<Difficulty, "Off">, number> = {
  Easy: 2,
  Medium: 5,
  Hard: 9,
};
export const DIFFICULTY_COLOR: Record<Difficulty, string> = {
  Off: C.muted,
  Easy: C.green,
  Medium: "#f5c542",
  Hard: "#ff5c5c",
};
